// extracted by mini-css-extract-plugin
export default {"container":"TableOneFooter_container__0kDfa","save":"TableOneFooter_save__bysSh","messages":"TableOneFooter_messages__-wcVT"};